export interface SensitiveEnvValues {
  oauthClientId: string;
  oauthSecret: string;
  mapboxToken: string;
  launchDarklyClientId: string;
  soilApiKey: string;
  datadogAppId: string;
  datadogClientToken: string;
}

const getSensitiveEnvValue = (envName: string): string =>
  process.env[envName] ?? "";

export const sensitiveEnv: SensitiveEnvValues = {
  oauthClientId: getSensitiveEnvValue("REACT_APP_OAUTH_CLIENT_ID"),
  oauthSecret: getSensitiveEnvValue("REACT_APP_OAUTH_SECRET"),
  mapboxToken: getSensitiveEnvValue("REACT_APP_MAPBOX_TOKEN"),
  launchDarklyClientId: getSensitiveEnvValue(
    "REACT_APP_LAUNCHDARKLY_CLIENT_ID"
  ),
  soilApiKey: getSensitiveEnvValue("REACT_APP_SOIL_API_KEY"),
  datadogAppId: getSensitiveEnvValue("REACT_APP_DATADOG_APP_ID"),
  datadogClientToken: getSensitiveEnvValue("REACT_APP_DATADOG_CLIENT_TOKEN"),
};
